import React, { useState, useRef, useEffect } from "react";
import {
  getProductsAll,
  softDeleteProduct,
  getWebSync,
  webPublishProduct,
} from "../../Services/ProductService";
import { getLanguages } from "../../Services/LanguageService";
import { getSegmentAll } from "../../Services/SegmentService";
import { getCategoryAll } from "../../Services/CategoryService";
import { getSubcategoryAll } from "../../Services/SubcategoryService";
import { sapSync } from "../../Services/SAPService";
import {
  genProductExport,
  getExportFile,
  getImportFile,
  deleteExportFile,
  deleteFileById,
  executeFile,
  uploadFile,
} from "../../Services/FileService";
import Overlay from "../../Components/Overlay/Overlay";
import MTable from "../../Components/MTable/MTable";
import { NavLink, useNavigate } from "react-router-dom";
import {
  handlerFormError,
  importProductAlert,
  sapSyncAlert,
  uuid,
  webSyncAlert,
} from "../../Utils/Utils";
import { useSelector } from "react-redux";
import { InputSwitch } from "primereact/inputswitch";
import Modal from "../../Components/Layout/Modal";
import { toastError, toastSuccess } from "../../Components/Toasts/Toast";
import { excel } from "../../Images";
import Swal from "sweetalert2";
import { Button } from "primereact/button";
import ErrorFileUpload from "../../Components/Product/FileHandler/ErrorFileUpload";
import { check, send } from "../../Images/index";
import CountryFlag from "../../Components/CouontryFlag/CountryFlag";
import { getAllAssembles } from "../../Services/AssemblyServices";

const { $ } = window;
const modalId = "#product-list-modal";
const modalId2 = "#product-download";
const modalId3 = "#product-upload";

let processingId = -1;
let processingId2 = -1;

const ProductPage = () => {
  const darkMode = useSelector((state) => state.theme.darkMode);
  let { userInfo } = useSelector((state) => state.auth);
  const navigate = useNavigate();
  const mTable = useRef();
  const [showAll, setShowAll] = useState(false);

  const [state, setState] = useState({
    checked: [],
    checkAll: [],
    customFilter: "",
    segments: [],
    categories: [],
    subcategories: [],
    products: [],
    params: {},
    selectedItem: null,
    languages: [],
    assembles: [],
    lang_code_1: null,
    lang_code_2: null,
    assembly: null,
    fileExport: null,
    files: [],
    processing: false,
    processing2: false,
  });

  const startProcessing2 = () => {
    processingId2 = setTimeout(() => {
      setState({ ...state, processing2: true });
    }, 150);
  };

  const stopProcessing2 = () => {
    clearTimeout(processingId2);
    setState({ ...state, processing2: false });
  };

  const startProcessing = () => {
    processingId = setTimeout(() => {
      setState({ ...state, processing: true });
    }, 150);
  };

  const stopProcessing = () => {
    clearTimeout(processingId);
    setState({ ...state, processing: false });
  };

  const onSetLanguage = (e) => {
    setState({ ...state, [e.target.name]: e.target.value });
  };

  const onGenFile = () => {
    if (lang_code_1 === "" || lang_code_1 === null) {
      toastError("Please choose the language #1 !");
      return;
    }

    if (lang_code_2 === "" || lang_code_2 === null) {
      toastError("Please choose the language #2 !");
      return;
    }

    if (lang_code_1 === lang_code_2) {
      toastError("Language #1 and #2 must be different!");
      return;
    }

    if (assembly === "" || assembly === null) {
      toastError("Please choose the Assembly process !");
      return;
    }

    startProcessing();
    const response = genProductExport({
      lang_code_1: lang_code_1,
      lang_code_2: lang_code_2,
      assembly: assembly,
    });
    response
      .then((res) => {
        if (res.status == 200 || res.status == 201) {
          toastSuccess(res.data.message);
          if (res.data.fileExport) {
            setTimeout(() => {
              setState({
                ...state,
                fileExport: res.data.fileExport,
                lang_code_1: null,
                lang_code_2: null,
                assembly: null,
              });
            }, 150);
          }
        }
      })
      .catch(({ response: { data } }) => {
        toastError(data.message);
      })
      .finally((_) => stopProcessing());
  };

  const onDeleteFileTemp = (i) => {
    files.splice(i, 1);
    setState({ ...state, files });
  };

  const onDeleteFile = () => {
    startProcessing();
    const response = deleteExportFile("product_master");
    response
      .then((res) => {
        if (res.status == 200 || res.status == 201) {
          toastSuccess(res.data.message);
          setTimeout(() => {
            setState({
              ...state,
              fileExport: null,
              lang_code_1: null,
              lang_code_2: null,
            });
          }, 150);
        }
      })
      .catch(({ response: { data } }) => {
        toastError(data.message);
      })
      .finally((_) => stopProcessing());
  };

  const onDeleteFileImport = (id, index) => {
    startProcessing();
    const response = deleteFileById(id);
    response
      .then((res) => {
        if (res.status == 200 || res.status == 201) {
          toastSuccess(res.data.message);
          files.splice(index, 1);
          setTimeout(() => {
            setState({ ...state, files });
          }, 150);
        }
      })
      .catch(({ response: { data } }) => {
        toastError(data.message);
      })
      .finally((_) => stopProcessing());
  };

  const onExecuteFile = (id, index, action) => {
    startProcessing();
    const response = executeFile(id, action);
    response
      .then((res) => {
        if (res.status == 200 || res.status == 201) {
          files.splice(index, 1);
          setTimeout(() => {
            setState({ ...state, files });
          }, 150);

          Swal.fire({
            icon: res.data.total_imported ? "success" : "warning",
            title: res.data.total_imported ? "Import success" : "Import failed",
            html: importProductAlert(res.data),
          });
        }
      })
      .catch(({ response: { data } }) => {
        files.splice(index, 1);
        setTimeout(() => {
          setState({ ...state, files });
        }, 150);

        Swal.fire({
          icon: data.total_imported ? "success" : "warning",
          title: data.total_imported ? "Import success" : "Import failed",
          html: importProductAlert(data),
        });
      })
      .finally((_) => stopProcessing());
  };

  const setChange = (e) => {
    if (e.target.name === "id_segment") {
      if (e.target.value == "") {
        setState({ ...state, params: null, categories: [], subcategories: [] });
      } else {
        getCategoryAll({
          perpage: 100,
          filter: `id_segment:${e.target.value}`,
        }).then((res) => {
          setState({
            ...state,
            categories: res.data.data,
            params: { [e.target.name]: e.target.value },
          });
        });
      }
    } else if (e.target.name === "id_category") {
      if (e.target.value == "") {
        setState({ ...state, subcategories: [] });
      } else {
        getSubcategoryAll({
          perpage: 100,
          filter: `id_category:${e.target.value}`,
        }).then((res) => {
          setState({
            ...state,
            subcategories: res.data.data,
            params: { [e.target.name]: e.target.value },
          });
        });
      }
    } else if (e.target.name === "id_sub_category") {
      if (e.target.value != "") {
        setState({
          ...state,
          params: { [e.target.name]: e.target.value },
        });
      }
    }
  };

  const onAddData = () => {
    if (!userInfo.access.master_product.can_create) {
      return;
    }
    navigate("add/new");
  };

  const onRowClick = (item) => {
    setState({ ...state, selectedItem: item });
    setTimeout(() => {
      $(modalId).modal("show");
    }, 150);
  };

  const onActiveChange = (item) => (e) => {
    if (!userInfo.access.master_product?.can_update) {
      toastError("You dont have permission for this action");
      return;
    }

    const status = e.target.value ? "Activate" : "Inactive";
    softDeleteProduct(item.item_code, { is_active: e.target.value })
      .then((res) => {
        toastSuccess(`${status} ${item.model_code} success`);
        mTable.current.refresh();
      })
      .catch(({ response: { err } }) => {
        toastError(`${status} ${item.model_code} failed.`);
      });
  };

  const onPublishWebChange = (item) => (e) => {
    if (!userInfo.access.master_product?.can_update) {
      toastError("You dont have permission for this action");
      return;
    }

    const status = e.target.value ? "Publish" : "Hide";
    webPublishProduct(item.item_code, { is_publish_web: e.target.value })
      .then((res) => {
        toastSuccess(`${status} ${item.model_code} to website success`);
        mTable.current.refresh();
      })
      .catch(({ response: { err } }) => {
        toastError(`${status} ${item.model_code} to website failed.`);
      });
  };

  const onFileChange = (e) => {
    if (files.length <= 2) {
      const _files = [...files, ...e.target.files];
      setState({ ...state, files: _files });
    } else {
      toastError("Maximum file is reached!");
    }
  };

  const onFileUpload = (i) => {
    const formData = new FormData();
    const file = files[i];
    formData.append("file", file);

    const response = uploadFile("product_master", formData);
    startProcessing();
    response
      .then((res) => {
        if (res.status == 200 || res.status == 201) {
          toastSuccess("File upload success");
          files[i] = res.data.data;
          setTimeout(() => {
            setState({ ...state, files });
          }, 150);
        }
      })
      .catch(({ response: { data } }) => {
        handlerFormError(data);
      })
      .finally((_) => stopProcessing());
  };

  const columns = [
    {
      id: uuid(),
      title: "Code",
      field: "item_code",
      style: { width: 85 },
      sortable: true,
      clickable: true,
    },
    {
      id: uuid(),
      title: "Model",
      field: "model_code",
      sortable: true,
      style: { width: 120 },
      clickable: true,
    },
    {
      id: uuid(),
      title: "Name",
      field: "item_name",
      style: { width: 205 },
      sortable: true,
      clickable: true,
    },
    {
      id: uuid(),
      title: "Series",
      field: "series",
      style: { width: 55 },
      sortable: true,
      clickable: true,
    },
    {
      id: uuid(),
      title: "Segment",
      field: "segment_name",
      sortable: false,
      style: { width: 55 },
      clickable: true,
    },
    {
      id: uuid(),
      title: "Category",
      field: "category_name",
      sortable: false,
      clickable: true,
      style: { width: 55 },
    },
    {
      id: uuid(),
      title: "Country",
      field: "country_name",
      style: { width: 55 },
      sortable: true,
      clickable: true,
      render: (item) => {
        return item.country_name ? (
          <p>{item.country_name}</p>
        ) : (
          <p className="text-red">Not Set</p>
        );
      },
    },
    {
      id: uuid(),
      title: "Created by",
      field: "created_by",
      sortable: false,
      clickable: true,
      style: { width: 55 },
    },
    {
      id: uuid(),
      title: "Approval",
      field: "is_creation_approved",
      style: { width: 55 },
      render: (item) => {
        if (item.is_creation_approved == false) {
          if (
            item.incident_status == "ONPROGRESS" ||
            item.incident_status_detail == "ONPROGRESS"
          ) {
            return (
              <span
                className="badge badge-info"
                style={{ color: "#FFF", padding: "6px" }}
              >
                ON PROGRESS
              </span>
            );
          } else if (
            item.incident_status == "REJECTED" ||
            item.incident_status_detail == "REJECTED"
          ) {
            return (
              <span
                className="badge badge-danger"
                style={{ color: "#FFF", padding: "6px" }}
              >
                REJECTED
              </span>
            );
          } else if (
            item.incident_status == "ONREVISED" ||
            item.incident_status_detail == "ONREVISED"
          ) {
            return (
              <span
                className="badge badge-warning"
                style={{ color: "#FFF", padding: "6px" }}
              >
                NEED REVISION
              </span>
            );
          } else {
            return (
              <span
                className="badge badge-warning"
                style={{ color: "#FFF", padding: "6px" }}
              >
                PENDING
              </span>
            );
          }
        } else {
          if (
            item.incident_status == "ONPROGRESS" ||
            item.incident_status_detail == "ONPROGRESS"
          ) {
            return (
              <span
                className="badge badge-info"
                style={{ color: "#FFF", padding: "6px" }}
              >
                ON PROGRESS
              </span>
            );
          } else if (
            item.incident_status == "ONREVISED" ||
            item.incident_status_detail == "ONREVISED"
          ) {
            return (
              <span
                className="badge badge-warning"
                style={{ color: "#FFF", padding: "6px" }}
              >
                NEED REVISION
              </span>
            );
          } else if (
            (item.incident_status == "COMPLETED" ||
              item.incident_status_detail == "COMPLETED") &&
            !item.incident_status &&
            item.is_creation_approved == true
          ) {
            if (item.incident_status_detail == "COMPLETED")
              return (
                <span
                  className="badge badge-success"
                  style={{ color: "#FFF", padding: "6px" }}
                >
                  COMPLETED
                </span>
              );
            else
              return (
                <span
                  className="badge badge-success"
                  style={{ color: "#FFF", padding: "6px" }}
                >
                  VALIDATED
                </span>
              );
          } else if (
            item.incident_status == "REJECTED" ||
            item.incident_status_detail == "REJECTED"
          ) {
            return (
              <span
                className="badge badge-danger"
                style={{ color: "#FFF", padding: "6px" }}
              >
                REJECTED
              </span>
            );
          } else if (
            item.incident_status == "NOT SUBMITTED" ||
            item.incident_status_detail == "NOT SUBMITTED" ||
            (!item.incident_status && !item.incident_status_detail)
          ) {
            return (
              <span
                className="badge badge-success"
                style={{ color: "#FFF", padding: "6px" }}
              >
                VALIDATED
              </span>
            );
          }
        }
      },
    },
    {
      id: uuid(),
      title: "Sync?",
      field: "is_sync",
      sortable: true,
      style: { width: 5 },
      options: [
        {
          label: "Sync",
          value: 1,
        },
        {
          label: "Not Sync",
          value: 0,
        },
      ],
      render: (item) => {
        return item.is_sync == 1 &&
          (item.incident_status == "COMPLETED" ||
            item.incident_status_detail == "COMPLETED" ||
            item.incident_status == "VALIDATED" ||
            item.incident_status_detail == "VALIDATED") ? (
          <img src={check} alt="check" style={{ width: 30, height: 30 }} />
        ) : (
          <img src={send} alt="send" style={{ width: 30, height: 30 }} />
        );
      },
    },
    /*{
      id: uuid(),
      title: "WebSync?",
      field: "is_sync_web",
      style: { width: 55 },
      sortable: true,
      options: [
        {
          label: "Sync",
          value: 1,
        },
        {
          label: "Not Sync",
          value: 0,
        },
      ],
      style: { width: 25 },
      render: (item) => {
        return item.is_sync_web == 1 ? (
          <img src={check} alt="check" style={{ width: 30, height: 30 }} />
        ) : (
          <img src={send} alt="send" style={{ width: 30, height: 30 }} />
        );
      },
    },*/
  ];

  const onRowChecked = (checked) => {
    setState({ ...state, checked });
  };

  const onSapSync = () => {
    Swal.fire({
      icon: "question",
      title: "Are you sure?",
      text: `${checked.length} data will sync to SAP`,
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
    }).then(({ isConfirmed }) => {
      if (isConfirmed) {
        startProcessing2();
        sapSync(checked)
          .then((response) => {
            Swal.fire({
              icon: "success",
              title: "Sync success",
              html: sapSyncAlert(response.data.response),
            }).then((res) => {
              mTable.current.refresh();
            });
          })
          .catch((response) => {
            Swal.fire({
              icon: "warning",
              title: "Sync failed!",
              html: sapSyncAlert(response.response.data.response),
            }).then((res) => {
              mTable.current.refresh();
            });
          })
          .finally((_) => stopProcessing2());
      }
    });
  };

  const onWebSync = () => {
    if (checked.length > 10) {
      Swal.fire({
        icon: "warning",
        title: "Warning",
        html: "Web sync can't more than 10 products",
      });
    } else {
      Swal.fire({
        icon: "question",
        title: "Are you sure?",
        text: `${checked.length} data will sync to Website`,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
      }).then(({ isConfirmed }) => {
        if (isConfirmed) {
          startProcessing2();
          getWebSync(checked)
            .then((response) => {
              Swal.fire({
                icon: "success",
                title: "Sync process completed",
                html: webSyncAlert(response.data),
              }).then((res) => {
                mTable.current.refresh();
              });
            })
            .catch((response) => {
              Swal.fire({
                icon: "warning",
                title: "Sync process failed!",
                html: webSyncAlert(response.data),
              }).then((res) => {
                mTable.current.refresh();
              });
            })
            .finally((_) => stopProcessing2());
        }
      });
    }
  };

  const filterAction = () => {
    if (params) {
      const obj = Object.keys(params);
      setState({ ...state, customFilter: `${obj[0]}:${state.params[obj[0]]}` });
    } else {
      setState({ ...state, customFilter: null });
    }
  };

  const onCloseModal = () => {
    $(modalId).modal("hide");
  };

  const onCloseModal2 = () => {
    $(modalId2).modal("hide");
  };

  const onCloseModal3 = () => {
    $(modalId3).modal("hide");
  };

  const onEdit = () => {
    $(modalId).modal("hide");
    setTimeout(() => {
      navigate(`edit/${selectedItem.item_code} `);
    }, 50);
  };

  const onEditDetail = () => {
    $(modalId).modal("hide");
    setTimeout(() => {
      navigate(
        `/product-detail-form/${selectedItem.country_code}/${selectedItem.item_code} `
      );
    }, 50);
  };

  const onDownload = () => {
    $(modalId2).modal("show");
  };

  const onUpload = () => {
    $(modalId3).modal("show");
  };

  const filterForm = (
    <div className="row p-1">
      <div className="col-md-12">
        <div className="form-group">
          <label htmlFor="prefix">Product Segment</label>
          <select
            className="form-control"
            name="id_segment"
            onChange={setChange}
          >
            <option value="">Select Segment</option>
            {state.segments.map((item, i) => {
              return (
                <option value={item.id} key={i}>
                  {item.segment_name}
                </option>
              );
            })}
          </select>
        </div>
      </div>
      <div className="col-md-12">
        <div className="form-group">
          <label htmlFor="prefix">Product Category</label>
          <select
            className="form-control"
            name="id_category"
            onChange={setChange}
          >
            <option value="">Select Category</option>
            {state.categories.map((item, i) => {
              return (
                <option value={item.id} key={i}>
                  {item.category_name}
                </option>
              );
            })}
          </select>
        </div>
      </div>
      <div className="col-md-12">
        <div className="form-group">
          <label htmlFor="prefix">Product Subcategory</label>
          <select
            className="form-control"
            name="id_sub_category"
            onChange={setChange}
          >
            <option value="">Select Subcategory</option>
            {state.subcategories.map((item, i) => {
              return (
                <option value={item.id} key={i}>
                  {item.sub_category_name}
                </option>
              );
            })}
          </select>
        </div>
      </div>
    </div>
  );

  const {
    processing,
    processing2,
    customFilter,
    params,
    selectedItem,
    languages,
    assembles,
    lang_code_1,
    lang_code_2,
    assembly,
    fileExport,
    files,
    checked,
    checkAll,
  } = state;

  const showAllFunc = () => {
    setShowAll(!showAll);
    mTable.current.refresh();
  };

  const [showPending, setShowPending] = useState(false);
  const [showDetailPending, setShowDetailPending] = useState(false);
  const showPendingRevisionButton = (e) => {
    setShowPending(!showPending);
    mTable.current.refresh();
  };

  const showDetailPendingRevisionButton = (e) => {
    setShowDetailPending(!showDetailPending);
    mTable.current.refresh();
  };

  const PendingRevisionButton = () => {
    return (
      <div
        className="form-check"
        id={`all-active-check${darkMode ? "-dark" : ""}`}
      >
        <input
          className={`form-check-input ${
            darkMode ? "customized-input-dark" : "customized-input"
          }`}
          type="checkbox"
          checked={showPending}
          onChange={showPendingRevisionButton}
        />
        <label className="form-check-label">
          Show master data pending your revision
        </label>
      </div>
    );
  };

  const DetailPendingRevisionButton = () => {
    return (
      <div
        className="form-check"
        id={`all-active-check${darkMode ? "-dark" : ""}`}
      >
        <input
          className={`form-check-input ${
            darkMode ? "customized-input-dark" : "customized-input"
          }`}
          type="checkbox"
          checked={showDetailPending}
          onChange={showDetailPendingRevisionButton}
        />
        <label className="form-check-label">
          Show detail data pending your revision
        </label>
      </div>
    );
  };

  const propsTable = {
    columns,
    showAllState: showAll,
    showAllFunc,
    getData: (params) => {
      if (!showAll) {
        if (params.filter) params.filter += "," + `is_active:true`;
        else params.filter = "is_active:true";
      }
      if (showPending) {
        if (params.filter)
          params.filter += "," + `next_step_nik:${userInfo.nik}`;
        else params.filter = `next_step_nik:${userInfo.nik}`;
      }
      if (showDetailPending) {
        if (params.filter)
          params.filter += "," + `next_step_nik_detail:${userInfo.nik}`;
        else params.filter = `next_step_nik_detail:${userInfo.nik}`;
      }
      const filters = params?.filterAnd?.split(",");
      if (filters) {
        let processedFilters = "";
        let i = 0;
        filters.forEach((filter) => {
          let [key, value] = filter.split(":");
          if (key == "is_creation_approved") {
            let val = "";
            value = value.trim();
            if (value.toUpperCase() == "PENDING") {
              processedFilters += `is_creation_approved:${false}`;
            } else {
              if (value.toUpperCase() == "ON PROGRESS") val = "ONPROGRESS";
              else if (value.toUpperCase() == "NEED REVISION")
                val = "ONREVISED";
              else if (value.toUpperCase() == "COMPLETED") val = "COMPLETED";
              else if (value.toUpperCase() == "REJECTED") val = "REJECTED";
              else if (value.toUpperCase() == "VALIDATED")
                val = "NOT SUBMITTED";
              processedFilters += `incident_status:${val},incident_status_detail:${val},is_creation_approved:${true}`;
            }
          } else {
            processedFilters += `${key}:${value}`;
          }
          if (i < filters.length - 1) processedFilters += ",";
          i++;
        });
        params.filterAnd = processedFilters;
      }

      return getProductsAll({ ...params });
    },
    showIndex: true,
    showAddButton: userInfo.access.master_product.can_create,
    onAddData,
    filterChilds: { view: filterForm, action: filterAction },
    enableFilter: true,
    rowClick: onRowClick,
    rowSelector: "item_code",
    orders: "sort:desc",
    checkbox: "item_code",
    checked,
    checkAll,
    onChecked: onRowChecked,
    hideCheckbox: (item) => {
      if (item.is_creation_approved == false) {
        return true;
      } else {
        return false;
      }
    },
    // disabledCheckbox: 'is_sync',
  };

  useEffect(() => {
    const reqSegment = getSegmentAll({ perpage: 1000 }).then(
      (res) => res.data.data
    );
    const reqLang = getLanguages({
      orders: "language_name:asc",
      perpage: 1000,
    }).then((res) => res.data.data);
    const reqExportFile = getExportFile("product_master").then(
      (res) => res.data
    );
    const reqImport = getImportFile("product_master").then((res) => res.data);
    const reqAssemble = getAllAssembles({ perpage: 1000 }).then(
      (res) => res.data.data
    );
    Promise.all([
      reqSegment,
      reqLang,
      reqExportFile,
      reqImport,
      reqAssemble,
    ]).then((results) => {
      const [_segment, _langs, _fileExport, _fileImport, _assembles] = results;
      const fExport = _fileExport.status != 404 ? _fileExport : null;
      const fImport = _fileImport.status != 404 ? _fileImport : [];
      setTimeout(() => {
        setState({
          ...state,
          languages: _langs,
          fileExport: fExport,
          files: fImport,
          segments: _segment,
          assembles: _assembles,
        });
      }, 100);
    });
  }, []);

  return (
    <div className="content-wrapper">
      <div className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-4">
              <h4
                style={{
                  marginTop: "0.5rem",
                  marginLeft: "0.2rem",
                  fontWeight: "400",
                }}
              >
                Product Data Management{" "}
              </h4>
              <h6
                style={{
                  marginLeft: "0.2rem",
                  fontWeight: "200",
                  letterSpacing: "1.2px",
                }}
              >
                Your central hub for product information
              </h6>
            </div>
            <div className="col-sm-8">
              <ol className="breadcrumb float-sm-right">
                <li className="breadcrumb-item">
                  <NavLink to="/home">Home</NavLink>
                </li>
                <li className="breadcrumb-item active">Products</li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <div className="card">
                <Overlay display={processing2} />
                <div className="card-body">
                  <div className="col-md-12 mb-3 d-flex flex-row justify-content-start align-items-center">
                    <button
                      className="btn btn-default btn-md mr-2"
                      onClick={onDownload}
                      disabled={!userInfo.access.master_product.can_view}
                    >
                      <i className="fas fa-download" /> Download
                    </button>
                    <button
                      className="btn btn-default btn-md mr-2"
                      onClick={onUpload}
                      disabled={!userInfo.access.master_product.can_view}
                    >
                      <i className="fas fa-upload" /> Upload
                    </button>
                    <button
                      className="btn btn-info btn-md mr-2"
                      disabled={
                        checked.length == 0 ||
                        !userInfo.access.master_product.can_view
                      }
                      onClick={onSapSync}
                    >
                      <i className="fas fa-sync" /> SAP Sync
                    </button>
                    <button
                      className="btn btn-warning btn-md mr-2"
                      disabled={
                        checked.length == 0 ||
                        !userInfo.access.master_product.can_view
                      }
                      onClick={onWebSync}
                    >
                      <i className="fas fa-sync" /> WEB Sync
                    </button>
                  </div>
                  <div className="col-md-12">
                    <ErrorFileUpload refresh={state} />
                  </div>
                  <div className="col-md-12">
                    <div
                      style={{
                        display: "flex",
                        marginBottom: "1rem",
                        columnGap: "1rem",
                      }}
                    >
                      <PendingRevisionButton />
                      <DetailPendingRevisionButton />
                    </div>
                    <MTable
                      ref={mTable}
                      {...propsTable}
                      showIndex={true}
                      customFilter={customFilter}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Modal
        id={modalId}
        title={"Product Overview"}
        onClose={onCloseModal}
        modalSize="modal-lg"
        btnActionName="Edit Product"
        btnSecondActionName="Edit Product Detail"
        disabledBtnSecond={selectedItem?.is_creation_approved == false}
        onAction={
          userInfo.access.master_product.can_update ? onEdit : undefined
        }
        onSecondAction={
          userInfo.access.master_product.can_update ? onEditDetail : undefined
        }
      >
        {selectedItem && (
          <div className="row">
            <div className="col-md-6">
              <div className="form-group">
                <label>SKU Number</label>
                <p className="mt-n2">{selectedItem.item_code}</p>
              </div>
              <div className="form-group mt-n2">
                <label>Item Name</label>
                <p className="mt-n2">{selectedItem.item_name}</p>
              </div>
              <div className="form-group mt-n2">
                <label>Series</label>
                <p className="mt-n2">{selectedItem.series}</p>
              </div>
              <div className="form-group mt-n2">
                <label>Model Code</label>
                <p className="mt-n2">{selectedItem.model_code}</p>
              </div>
              <div className="form-group mt-n2">
                <label>Dimensions</label>
                <br />
                <span className="mt-n2">
                  Height:{" "}
                  <span className="text-bold">{selectedItem.height} mm</span>
                </span>
                <br />
                <span className="mt-n2">
                  Width:{" "}
                  <span className="text-bold">{selectedItem.width} mm</span>
                </span>
                <br />
                <span className="mt-n2">
                  Length:{" "}
                  <span className="text-bold">{selectedItem.length} mm</span>
                </span>{" "}
                <br />
                <span className="mt-n2">
                  Weight:{" "}
                  <span className="text-bold">{selectedItem.weight} kg</span>
                </span>
                <br />
                <span className="mt-n2">
                  Volume:{" "}
                  <span className="text-bold">{selectedItem.volume} kgv</span>
                </span>
              </div>
              <div className="form-group mt-n2">
                <label>Package Dimensions</label>
                <br />
                <span className="mt-n2">
                  Outer Height:{" "}
                  <span className="text-bold">
                    {selectedItem.outer_height} mm
                  </span>
                </span>
                <br />
                <span className="mt-n2">
                  Outer Width:{" "}
                  <span className="text-bold">
                    {selectedItem.outer_width} mm
                  </span>
                </span>
                <br />
                <span className="mt-n2">
                  Outer Weight:{" "}
                  <span className="text-bold">
                    {selectedItem.outer_weight} kg
                  </span>
                </span>
                <br />
                <span className="mt-n2">
                  Outer Length:{" "}
                  <span className="text-bold">
                    {selectedItem.outer_length} mm
                  </span>
                </span>
              </div>
              <div className="form-group mt-n2">
                <label>Assembly</label>
                <p className="mt-n2">{selectedItem.assembly}</p>
              </div>
              <div className="form-group mt-n2">
                <label>Unit</label>
                <p className="mt-n2">{selectedItem.unit}</p>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group mt-n2">
                <label>Segment</label>
                <p className="mt-n2">{selectedItem.segment_name}</p>
              </div>
              <div className="form-group mt-n2">
                <label>Category</label>
                <p className="mt-n2">{selectedItem.category_name}</p>
              </div>
              <div className="form-group mt-n2">
                <label>Subcategory</label>
                <p className="mt-n2">{selectedItem.sub_category_name}</p>
              </div>
              {selectedItem.country_code && (
                <div className="form-group mt-n2">
                  <label>Country</label>
                  <p className="mt-n2">
                    <CountryFlag code={selectedItem.country_code} />
                    {selectedItem.country_name
                      ? selectedItem.country_name
                      : "Name Unknown"}
                  </p>
                </div>
              )}
              <div className="form-group mt-n2">
                <label>Is Active</label>
                <br />
                <InputSwitch disabled={true} checked={selectedItem.is_active} />
              </div>
              <div className="form-group mt-n2">
                <label>Is Sync?</label>
                <br />
                {selectedItem.is_sync ? (
                  <>
                    <img src={check} style={{ width: 30, height: 30 }} />{" "}
                    <span>Synced!</span>
                  </>
                ) : (
                  <>
                    <img src={send} style={{ width: 30, height: 30 }} />{" "}
                    <span>Not Synced!</span>
                  </>
                )}
              </div>
            </div>
          </div>
        )}
      </Modal>

      <Modal
        id={modalId2}
        title={"Download Product"}
        onClose={onCloseModal2}
        modalSize="modal-md"
      >
        <Overlay display={processing} />
        {!fileExport ? (
          <div>
            <div className="form-group">
              <label htmlFor="lang_code_1">Language #1</label>
              <select
                className="form-control"
                name="lang_code_1"
                onChange={onSetLanguage}
              >
                <option value="">Select Language #1</option>
                {languages.map((item, i) => {
                  return (
                    <option value={item.language_code} key={i}>
                      {item.language_name}
                    </option>
                  );
                })}
              </select>
            </div>

            <div className="form-group">
              <label htmlFor="lang_code_2">Language #2</label>
              <select
                className="form-control"
                name="lang_code_2"
                onChange={onSetLanguage}
              >
                <option value="">Select Language #2</option>
                {languages.map((item, i) => {
                  return (
                    <option value={item.language_code} key={i}>
                      {item.language_name}
                    </option>
                  );
                })}
              </select>
            </div>

            <div className="form-group">
              <label htmlFor="assembly">Assembly Process</label>
              <select
                className="form-control"
                name="assembly"
                onChange={onSetLanguage}
              >
                <option value="">Select Assembly Type</option>
                <option value="all">All Assembly Type</option>
                {assembles.map((item, i) => {
                  return (
                    <option value={item.name} key={i}>
                      {item.name}
                    </option>
                  );
                })}
              </select>
            </div>
            <button
              className="btn btn-warning btn-md w-100"
              onClick={onGenFile}
            >
              Generate File
            </button>
          </div>
        ) : (
          <div>
            <div className="p-1 text-center">
              <img src={excel} alt="excel" style={{ width: 80, height: 80 }} />
              <p>{fileExport.file_name}</p>
              <button
                className="btn btn-danger btn-md mr-3 w-25"
                onClick={onDeleteFile}
              >
                Delete
              </button>
              <a
                href={fileExport.file_url}
                target="_blank"
                download
                className="btn btn-warning btn-md w-25"
              >
                Download
              </a>
            </div>
          </div>
        )}
      </Modal>

      <Modal
        id={modalId3}
        title={"Upload Product"}
        onClose={onCloseModal3}
        modalSize="modal-lg"
      >
        <Overlay display={processing} />
        <div
          className="card w-100 p-2"
          style={{ border: "1px solid #ccc", borderRadius: 5 }}
        >
          <div className="card-body d-flex flex-row justify-content-center">
            {files.length > 0 &&
              files.map((item, i) => {
                return item.file_url ? (
                  <div
                    key={i}
                    className="card d-flex flex-column align-items-center p-2"
                    style={
                      i > 0
                        ? {
                            border: "1px solid #ccc",
                            borderRadius: 5,
                            marginLeft: 20,
                          }
                        : { border: "1px solid #ccc", borderRadius: 5 }
                    }
                  >
                    <div
                      className=""
                      style={{ position: "absolute", top: -10, right: -10 }}
                    >
                      <Button
                        type="button"
                        className="p-button-rounded p-button-danger"
                        icon="pi pi-times"
                        style={{ width: 30, height: 30 }}
                        onClick={() => onDeleteFileImport(item.id, i)}
                      />
                    </div>
                    <img
                      src={excel}
                      alt="excel"
                      style={{ width: 80, height: 80 }}
                    />
                    <p style={{ wordBreak: "break-word" }}>{item.file_name}</p>
                    <div className="d-flex">
                      <button
                        className="btn btn-info btn-xs mr-2"
                        onClick={() => onExecuteFile(item.id, i, "create")}
                      >
                        Create
                      </button>
                      <button
                        className="btn btn-warning btn-xs"
                        onClick={() => onExecuteFile(item.id, i, "update")}
                      >
                        Update
                      </button>
                    </div>
                  </div>
                ) : (
                  <div
                    key={i}
                    className="card d-flex flex-column align-items-center p-2 mr-2"
                    style={
                      i > 0
                        ? {
                            border: "1px solid #ccc",
                            borderRadius: 5,
                            marginLeft: 20,
                          }
                        : { border: "1px solid #ccc", borderRadius: 5 }
                    }
                  >
                    <img
                      src={excel}
                      alt="excel"
                      style={{ width: 80, height: 80 }}
                    />
                    <p style={{ wordBreak: "break-word" }}>{item.name}</p>
                    <div className="d-flex">
                      <button
                        className="btn btn-danger btn-xs mr-2"
                        onClick={() => onDeleteFileTemp(i)}
                      >
                        Delete
                      </button>
                      <button
                        className="btn btn-default btn-xs"
                        onClick={() => onFileUpload(i)}
                      >
                        Upload
                      </button>
                    </div>
                  </div>
                );
              })}
          </div>
        </div>

        <div className="w-100 text-center">
          <input
            id="on-file-upload"
            className="d-none"
            type="file"
            accept="application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            onChange={onFileChange}
            key={uuid()}
          />
          <a
            type="button"
            className="btn btn-default"
            style={{ width: 120, border: "1px solid black" }}
            onClick={() => {
              window.$("#on-file-upload").click();
            }}
          >
            <i className="fa fa-file" /> Choose{" "}
          </a>
        </div>
      </Modal>
    </div>
  );
};

export default ProductPage;
